import React from 'react';

import { useScheduleFlow } from '@/contexts/ScheduleFlowContext';
import moment from 'moment';

import './DurationSummary.css';

interface DurationSummaryProps {}

const DurationSummary: React.FC<DurationSummaryProps> = () => {
  const { durationInMinutes } = useScheduleFlow();
  const labels = {
    estimatedDuration: 'Estimated Appointment Duration'
  };

  const formatDuration = (durationInMinutes: number) => {
    const duration = moment.duration(durationInMinutes, 'minutes');
    const durationInHours = duration.hours();
    const durationInRemainderMinutes = duration.minutes();
    if (durationInMinutes < 60) {
      return `${durationInMinutes} minutes`;
    } else {
      return (
        `${durationInHours} hour${durationInHours > 1 ? 's' : ''}` +
        (durationInRemainderMinutes > 0
          ? ` ${durationInRemainderMinutes} minutes`
          : '')
      );
    }
  };

  return (
    <div className="duration-summary">
      <div className="duration-detail">
        <p className="duration-detail__label">{labels.estimatedDuration}</p>
        <p className="duration-detail__value">
          ~{formatDuration(durationInMinutes)}
        </p>
      </div>
    </div>
  );
};

export default DurationSummary;
